import React from 'react'
import Modal from 'react-bootstrap/Modal'
import { TransformWrapper, TransformComponent } from 'react-zoom-pan-pinch'
import { IMAGE_URL } from '../../utils/constants'
import { CLASSES } from '../../assets/styles/styles'
import { Image } from 'react-bootstrap'

const ProductZoomView = ({ images, thumbnail, name }) => {
  const [item, setItem] = React.useState(0)
  const [show_modal, setShowModal] = React.useState(false)

  const placeholder = 'https://placehold.co/600x400'

  const [imgSrc, setImgSrc] = React.useState(placeholder)

  const _images =
    (images && JSON.parse(images)) || (thumbnail && [thumbnail]) || []

  React.useEffect(() => {
    setImgSrc(IMAGE_URL + _images[item])
  }, [item])

  const handleImageError = () => {
    setImgSrc(placeholder)
  }

  // const Controls = ({ zoomIn, zoomOut, resetTransform }) => (
  //   <div className='d-flex align-items-center justify-content-center zoom-controller'>
  //     <button className='zoom-button' onClick={() => zoomIn()}>
  //       +
  //     </button>
  //     <button className='zoom-button' onClick={() => zoomOut()}>
  //       -
  //     </button>
  //     {/* <button onClick={() => resetTransform()}>x</button> */}
  //   </div>
  // )

  return (
    <div className='w-100'>


      {/*main image */}
      <div className='w-100 bg-white p-3 overflow-hidden d-flex justify-content-center align-items-center'>
        <Image
          height={'367px'}
          src={imgSrc}
          alt={name || 'Product Image'}
          className='productinfo-image-preview pointer'
          onClick={() => setShowModal(true)}
          onError={handleImageError}
          // onMouseEnter={() => show_image_in_modal(state.modal_images)}
          // onMouseLeave={() => show_image_in_modal(state.modal_images)}
        />
      </div>


      {/* mini thumbnails list */}
      {_images.length > 1 && (
        <div
          style={{ height: 92 }}
          className='d-flex justify-content-center mt-2'
        >
          {_images.map((_item, i) => (
            <div
              onClick={() => setItem(i)}
              key={i}
              style={{
                height: '100%',
                width: '25%',
                border: item === i ? '1px solid #13A050' : '',
              }}
              className='bg-white pointer overflow-hidden d-flex justify-content-center p-1 mx-1'
            >
              <Image
                height={'100%'}
                src={IMAGE_URL + _item}
                alt='...'
                className='productinfo-image-preview'
              />
            </div>
          ))}
        </div>
      )}


      {/* image zooming modal */}
      <Modal
        show={show_modal}
        centered
        size='xl'
        onHide={() => setShowModal(false)}
        aria-labelledby='contained-modal-title-vcenter'
      >
        <Modal.Header closeButton className='border-0' />
        <Modal.Body className={CLASSES.content_center}>
          <TransformWrapper centerOnInit>
            {(utils) => (
              <React.Fragment>
                <TransformComponent
                  wrapperStyle={{ width: '100%' }}
                  wrapperClass='w-100'
                >
                  <Image
                    width={'100%'}
                    height={'367px'}
                    src={imgSrc}
                    alt='product image'
                    className='product_modal_images'
                  />
                </TransformComponent>
                {/* <Controls {...utils} /> */}
              </React.Fragment>
            )}
          </TransformWrapper>
        </Modal.Body>
        <Modal.Footer className='border-0 pt-4' />
      </Modal>
    </div>
  )
}

export default ProductZoomView
